import React, { Component } from 'react'
import { cx } from '@emotion/css'
import PropTypes from 'prop-types'
import { colors } from '@offerzen/pinata-shame'
import CaretUpIcon from '@offerzen/zenicon/CaretUpIcon'
import QuestionIcon from '@offerzen/zenicon/QuestionIcon'

import AccessibleIcon from '../AccessibleIcon'

import styles from './styles'

class NavVisibilityBadge extends Component {
  static propTypes = {
    currentState: PropTypes.string,
  }

  state = {
    open: false,
  }

  render() {
    const { currentState, trackVisibilityStatus } = this.props

    return (
      <div
        className={cx(styles.wrapper, currentState === 'live' ? styles.visibleWrapper : styles.notVisibleWrapper)}
        onMouseEnter={() => {
          this.setState({ open: true }), trackVisibilityStatus('open explainer')
        }}
        onMouseLeave={() => {
          this.setState({ open: false }), trackVisibilityStatus('close explainer')
        }}>
        <If condition={this.state.open}>
          <div className={styles.content}>
            <div className={styles.carat}>
              <AccessibleIcon icon={CaretUpIcon} size={40} color={colors.white} />
            </div>
            <Choose>
              <When condition={currentState === 'live'}>
                <p className={styles.contentText}>
                  Companies can view your profile and reach out with job opportunities. Try respond to interview requests within 48 hours as
                  companies might withdraw them.
                </p>
              </When>

              <Otherwise>
                <p className={styles.contentText}>
                  Companies are not able to view your profile. Keep your profile up to date to avoid having to do time consuming updates
                  when you are ready to start looking for a new job.
                </p>
              </Otherwise>
            </Choose>
          </div>
        </If>
        <strong>
          You are
          <Choose>
            <When condition={currentState === 'live'}>
              <span className={styles.visibleText}>visible</span>
            </When>
            <Otherwise>
              <span className={styles.notVisibleText}>not visible</span>
            </Otherwise>
          </Choose>
          to companies
        </strong>
        <AccessibleIcon className={styles.question} icon={QuestionIcon} size={14} color={colors.blueZodiac} />
      </div>
    )
  }
}

export default NavVisibilityBadge
